import { USER_ROLES } from 'admin/users/userUtils';
import { AuthContext } from 'common/providers/AuthContextProvider/AuthContextProvider';
import { Role, useCurrentUserQuery } from 'generated/graphql';
import { useContext } from 'react';
import { Create, RadioButtonGroupInput, SimpleForm, TextInput } from 'react-admin';

export const UserInvitationCreate: React.FC = () => {
  const { isAuthenticated } = useContext(AuthContext);
  const { data } = useCurrentUserQuery({ skip: !isAuthenticated });

  const hasAnyRole = (allowedRoles: Role[]) =>
    isAuthenticated && data?.user?.roles?.some((role: Role) => allowedRoles.includes(role));

  let allowedRoles: string[] = [];
  if (hasAnyRole([Role.RoleAdmin])) {
    allowedRoles = ['ROLE_FINANCIAL_ADVISOR', 'ROLE_SCOUT', 'ROLE_CLIENT', 'ROLE_ADMIN'];
  } else if (hasAnyRole([Role.RoleFinancialAdvisor])) {
    allowedRoles = ['ROLE_CLIENT'];
  } else if (hasAnyRole([Role.RoleScout])) {
    allowedRoles = ['ROLE_CLIENT'];
  }

  const filteredRoles = USER_ROLES.filter((role) => allowedRoles.includes(role.id));

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const transform = (data: any) => ({
    ...data,
    status: 'PENDING',
  });

  return (
    <Create redirect="/admin/UserInvitation" transform={transform}>
      <SimpleForm>
        <TextInput label="E-mail" source="email" sx={{ width: '40em' }} />
        <RadioButtonGroupInput
          choices={filteredRoles}
          defaultValue="ROLE_CLIENT"
          label="Rola"
          source="role"
          sx={{ width: '40em' }}
        />
      </SimpleForm>
    </Create>
  );
};
